import React from 'react';

export const FlagAlt = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--flag-alt';
  color = color || '#0076CC';

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <g clipPath="url(#clip0_13439_1326)">
        <path
          d="M4.5 13.1028H19.5L14.6786 8.28139L19.5 3.45996H4.5V20.6028"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13439_1326">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlagAlt;
